import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import type { EmailStatusConfig } from '../types'
import { statusIconTone } from './MessageStatusIcon.css'

export const MessageStatusIcon = ({
  statusConfig,
  className
}: {
  statusConfig: EmailStatusConfig | null
  className?: string
}): ReactElement | null => {
  if (!statusConfig) return null

  return (
    <Tooltip text={statusConfig.label} direction="top" asChild>
      <span className={clsx(className, statusIconTone[statusConfig.tone])}>
        <FontAwesomeIcon icon={statusConfig.icon} />
      </span>
    </Tooltip>
  )
}
